import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
var NglFigureCrop = (function () {
    function NglFigureCrop(element, renderer) {
        this.element = element;
        this.renderer = renderer;
    }
    Object.defineProperty(NglFigureCrop.prototype, "nglCrop", {
        set: function (ratio) {
            var nativeElement = this.element.nativeElement;
            if (this._ratio) {
                this.renderer.removeClass(nativeElement, "slds-image__crop--" + this._ratio);
            }
            if (ratio) {
                this.renderer.addClass(nativeElement, 'slds-image__crop');
                this.renderer.addClass(nativeElement, "slds-image__crop--" + ratio);
            }
            else {
                this.renderer.removeClass(nativeElement, 'slds-image__crop');
            }
            this._ratio = ratio;
        },
        enumerable: true,
        configurable: true
    });
    NglFigureCrop.decorators = [
        { type: Directive, args: [{
                    selector: '[nglCrop]',
                },] },
    ];
    /** @nocollapse */
    NglFigureCrop.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    NglFigureCrop.propDecorators = {
        'nglCrop': [{ type: Input },],
    };
    return NglFigureCrop;
}());
export { NglFigureCrop };
//# sourceMappingURL=figure-crop.js.map